<template>
    <div class="content" v-if="feature !== undefined">
        <h2>{{ feature.feature }}</h2>
        <div style="font-size: 16px; margin-bottom: 10px">
            <input type="checkbox" v-model="featureEnabled" @change="updateFeature"/>Enabled
        </div>
        <div>
            <transition name="fade">
                <div v-if="showEnabledOptions">
                    <input type="radio" id="one" :value="true" v-model="enabledForAccounts" @change="updateFeature">
                    <label for="one">Enabled For All Accounts</label>
                    <br>
                    <input type="radio" id="two" :value="false" v-model="enabledForAccounts" @change="updateFeature">
                    <label for="two">Enabled For Selected Accounts</label>
                    <transition name="fade">
                        <div v-if="!enabledForAccounts">
                            <div class="flex"  style="padding: 12px; border: 1px solid #ccc; margin: 12px 0">
                                <div style="width: 100%">
                                <label>Select Account:</label>
                                <v-select
                                    :options="accountList"
                                    v-model="selectedAccounts"
                                    :clearable="false"
                                    multiple
                                    :closeOnSelect="false"
                                    class="feature-account-selector"
                                    label="name"
                                    placeholder="Type name or space to find accounts"
                                >
                                    <template slot="no-options">
                                        Type name or space to find accounts
                                    </template>
                                </v-select>
                                </div>
                            </div>
                        </div>
                    </transition>

                </div>
            </transition>
        </div>
        <div style="justify-content: flex-end; display: flex;">
            <button class="bbutton" @click.prevent="saveSettings">Save</button>
        </div>
    </div>
    <div class="content" v-else>Loading...</div>
</template>

<script>
import axios from "axios";

export default {
    name: "FeatureFlag",
    data: function () {
        return {
            showEnabledOptions: false,
            showAccountEnabledOptions: false,
            accountList: [],
            selectedAccounts: [],
            featureEnabled: undefined,
            enabledForAccounts: undefined,
            feature: undefined,
        }
    },
    props: [
        'featureId',
    ],
    mounted() {
        axios.get(
            `/admin/feature-flag/${this.featureId}`
        ).then(res => {
            console.log(res)
            this.feature = res.data.data
            this.selectedAccounts = res.data.enabled_accounts?.map(d => {
                return {
                    "id": d.account_id,
                    "name": d.account_name
                }
            })
            this.featureEnabled = Boolean(this.feature.active_at)
            this.enabledForAccounts = Boolean(this.feature.enabled_for_all_accounts)
        });
        axios.get(
            `/accounts/all?search&only_active=1`
        ).then(res => {
            this.accountList = res.data ?? []
        });
    },
    watch: {
        featureEnabled: function (newVal) {
            this.showEnabledOptions = newVal
        },
    },
    methods: {
        updateFeature(){
            this.postFeatureSettings(
                this.feature.feature,
                this.featureEnabled,
                this.enabledForAccounts
            );
        },
        saveSettings() {
            const enabledAccountIDs = this.selectedAccounts.map(i => i.id)
            axios.post(
                `/admin/feature-flag/accounts`, {
                     'account_ids': enabledAccountIDs,
                     'feature_id': this.feature.id
                }
            ).then(() => alert('Successfully updated'));
        },
        postFeatureSettings(feature_name, active, enabled_for_all_accounts){
            return axios.post(
                `/admin/feature-flag`, {
                    feature_name: feature_name,
                    active: active,
                    enabled_for_all_accounts
                }
            )
        }
    }
}
</script>

<style scoped>
.feature-account-selector > .vs__selected-options {
    display: flex;
    flex-basis: 100%;
    flex-grow: 1;
    flex-wrap: wrap;
    padding: 0 2px;
    position: relative;
}
</style>
